import { PageHeader } from "@/components/site/PageHeader";
import { CommunitySection } from "@/components/sections/CommunitySection";
import { IMAGES } from "@/lib/content";

export default function Community() {
  return (
    <>
      <PageHeader label="Community" title="YOU'RE HELPING BUILD IT" image={IMAGES.parrot}>
        This isn't a broadcast — it's a build. Join the community and help shape the fish, the projects and
        the direction of the whole thing.
      </PageHeader>
      <CommunitySection />
    </>
  );
}
